import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { useApp } from '@/context/AppContext';
import { CreditCard, ChevronRight } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

export default function PagoStep() {
  const navigate = useNavigate();
  const { state, updateEleccionProgress } = useApp();
  const { metodoPago, equipoSeleccionado, mascarillaSeleccionada, bunoIncluido, maskSizing } = state.eleccion;
  const { toast } = useToast();

  // Handle header back button clicks
  useEffect(() => {
    const handleHeaderBack = () => {
      navigate('/eleccion/carrito');
    };

    window.addEventListener('headerBackClick', handleHeaderBack);
    return () => window.removeEventListener('headerBackClick', handleHeaderBack);
  }, [navigate]);

  const procederPago = () => {
    if (metodoPago) {
      // Mock del proceso de pago
      console.log('Payment completed:', {
        equipo: equipoSeleccionado,
        mascarilla: mascarillaSeleccionada,
        metodoPago,
        bunoIncluido,
        maskSizing
      });
      
      toast({
        title: "¡Compra exitosa!",
        description: "Tu equipo está en camino. Recibirás el tracking por WhatsApp."
      });
    }
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-80px)]">
      <div className="flex-1 container px-4 py-8 pb-24">
        <div className="max-w-2xl mx-auto">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CreditCard className="h-5 w-5" />
                Método de pago
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <RadioGroup 
                value={metodoPago} 
                onValueChange={(value) => updateEleccionProgress({ metodoPago: value })}
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="tarjeta" id="tarjeta" />
                  <Label htmlFor="tarjeta">Tarjeta (3 MSI disponibles)</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="transferencia" id="transferencia" />
                  <Label htmlFor="transferencia">Transferencia bancaria</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="bnpl" id="bnpl" />
                  <Label htmlFor="bnpl">Buy Now Pay Later (Aplazo/Kueski)</Label>
                </div>
              </RadioGroup>

              <Button 
                className="w-full min-h-touch text-lg gap-2" 
                onClick={procederPago} 
                disabled={!metodoPago}
              >
                Confirmar compra
                <ChevronRight className="h-4 w-4" />
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>

    </div>
  );
}